
import MyCarousel from "./utils/Owlcarousel";
import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect, useState } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
// import { listPlacements } from "../../server/apihelper";

import "owl.carousel";
import { Link, useParams } from "react-router-dom";
import { limitNews, addEnquiryForm, listGallery } from "../server/apihelper";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.theme.default.css";
import SEO from "../common-components/SEO";
import { ExperienceMcgans } from "./pages/Experienceatmcgans";
export const Main = () => {
  const VIRTUAL = process.env.REACT_APP_TOUR_Live_URL;
  const { id } = useParams();
  const [experienceCount, setExperienceCount] = useState(0);
  const [studentsCount, setStudentsCount] = useState("2K");
  const [nationalitiesCount, setNationalitiesCount] = useState(0);
  const [activeVideoIndex, setActiveVideoIndex] = React.useState(null);
  const [galleryImages, setGalleryImages] = useState([]);
  useEffect(() => {
    AOS.init();
    const fetchGallery = async () => {
      try {
        const query = `page=1&items_per_page=13`;
        const res = await listGallery(query);
        if (res?.data) {
          // filter only items that have an image field
          const images = res.data.filter((item) => item.image);
          setGalleryImages(images.slice(1, 30)); // ✅ limit to 10
        }
      } catch (error) {
        console.error("Error fetching gallery:", error);
      }
    };

    fetchGallery();
  }, []);
  // Static stories array (from student-story-details.js)
  const studentStoriesList = [
    // {
    //   title: "Aranganathan's Journey: From Aspiring Architect to Design Innovator",
    //   student_name: "Aranganathan",
    //   date: "2024-05-10",
    //   description: "B.Arch 4th Year Student",
    //   image: "",
    //   video: "https://www.youtube.com/watch?v=HKEK7eFOadY"
    // },

    {
      title: "Anushiya's Story: Crafting Spaces with Passion and Purpose",
      student_name: "Anushiya",
      date: "2023-11-22",
      description: "B.Arch 3rd Year Student",
      pra: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
when an unknown printer took a galley of type and scrambled it to make a type 
specimen book. It has survived not only five centuries, but also the leap into 
electronic typesetting, remaining essentially unchanged. It was popularised in 
the 1960s with the release of Letraset sheets.`,

      image: "",
      video: "https://www.youtube.com/watch?v=pvaHGfIwZqg"
    },
    {
      title: "Chalsie's Experience: Embracing Creativity and Community at McGAN'S",
      student_name: "Chalsie",
      date: "2022-08-15",
      description: "B.Arch 4th Year Student",
      pra: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
when an unknown printer took a galley of type and scrambled it to make a type 
specimen book. It has survived not only five centuries, but also the leap into 
electronic typesetting, remaining essentially unchanged. It was popularised in 
the 1960s with the release of Letraset sheets.`,

      image: "",
      video: "https://youtu.be/ntb9UCysfeg?si=36QRzuPaYBOqFDSV"
    },
    {
      title: "Harshith's Path: From First-Year Enthusiast to Future Architect",
      student_name: "Harshith",
      date: "2022-08-15",
      description: "B.Arch 1st Year Student",
      pra: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
when an unknown printer took a galley of type and scrambled it to make a type 
specimen book. It has survived not only five centuries, but also the leap into 
electronic typesetting, remaining essentially unchanged. It was popularised in 
the 1960s with the release of Letraset sheets.`,

      image: "",
      video: "https://www.youtube.com/watch?v=s6vdWqF0wks"
    },
    {
      title: "Kyati's Journey: Exploring Architecture at McGAN'S",
      student_name: "Kyati Golchha",
      date: "2022-08-15",
      description: "B.Arch 2nd Year Student",
      pra: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
when an unknown printer took a galley of type and scrambled it to make a type 
specimen book. It has survived not only five centuries, but also the leap into 
electronic typesetting, remaining essentially unchanged. It was popularised in 
the 1960s with the release of Letraset sheets.`,

      image: "",
      video: "https://www.youtube.com/watch?v=goJDHXfQsTU&list=PLFsYBPydyZDq5heF5sT6GfYc8-Ewyzw7W"
    },
    // Add more static stories as needed
  ];
  function getYouTubeID(url) {
    const regExp =
      /^.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[1].length === 11 ? match[1] : null;
  }


  const images = [
    "/assets/life/1.jpg",
    "/assets/life/2.jpg",
    "/assets/life/3.jpg",
    "/assets/life/4.jpg",
    "/assets/life/5.jpg",
    "/assets/life/6.jpg",
    "/assets/life/7.jpg",
    "/assets/life/8.jpg",
    "/assets/life/9.jpg",
    "/assets/life/10.jpg",
  ];

  // Image intrinsic-dimension hints to prevent CLS. Add entries here for known/static assets.
  const IMAGE_DIMS = {
    "/assets/images/banner/7.jpeg": { width: 1770, height: 765 },
    "/assets/images/placement/1.webp": { width: 1080, height: 1080 },
    "/assets/images/campus-life/lab.webp": { width: 6000, height: 4000 },
    "/assets/images/campus-life/library.webp": { width: 356, height: 251 },
    "/assets/images/campus-life/hostel.webp": { width: 6000, height: 4000 },
    // gallery / life defaults
    "__FALLBACK_GALLERY__": { width: 420, height: 280 },
    "__FALLBACK_LOGO__": { width: 100, height: 100 },
  };

  const getDims = (src) => {
    if (!src) return IMAGE_DIMS['__FALLBACK_GALLERY__'];
    const key = Object.keys(IMAGE_DIMS).find((k) => {
      if (k === '__FALLBACK_GALLERY__' || k === '__FALLBACK_LOGO__') return false;
      return src === k || (typeof src === 'string' && (src.endsWith(k) || src.includes(k.replace(/^\//, ''))));
    });
    if (key) return IMAGE_DIMS[key];
    if (src && (src.includes('/assets/images/placement/') || src.includes('/placement'))) {
      return IMAGE_DIMS['__FALLBACK_LOGO__'];
    }
    return IMAGE_DIMS['__FALLBACK_GALLERY__'];
  };

  const [newsLimit, setlimitNews] = useState([]);
  // Recruiter logos for company carousel
  const recruiter = [
    { image: "/assets/images/placement/1.webp" },
    { image: "/assets/images/placement/2.webp" },
    { image: "/assets/images/placement/3.webp" },
    { image: "/assets/images/placement/4.webp" },
    { image: "/assets/images/placement/5.webp" },
    { image: "/assets/images/placement/6.webp" },
    { image: "/assets/images/placement/7.webp" },
    { image: "/assets/images/placement/8.webp" },
    { image: "/assets/images/placement/9.webp" },
    // { image: "/assets/images/placement/10.webp" },
    { image: "/assets/images/placement/11.webp" },
    { image: "/assets/images/placement/12.webp" },
    { image: "/assets/images/placement/13.webp" },
    { image: "/assets/images/placement/14.webp" },
    { image: "/assets/images/placement/15.webp" },
    { image: "/assets/images/placement/16.webp" },
    { image: "/assets/images/placement/17.webp" },
    // { image: "/assets/images/placement/18.webp" },
    { image: "/assets/images/placement/19.webp" },
    { image: "/assets/images/placement/20.webp" },
    // Add more logos as needed
  ];
  const [enquiry, setEnquiry] = useState({
    name: "",
    phone: "",
    city: "",
    course: "",
    type: 1,
  });
  const [enquiryStatus, setEnquiryStatus] = useState("");
  const items_per_page = 3;
  useEffect(() => {
    AOS.init();
  }, []);
  useEffect(() => {
    // Initialize the Owl Carousel
    const $ = window.$; // Ensure jQuery is available
    $(".campus-slider").owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      responsive: {
        0: { items: 1 },
        600: { items: 2 },
        1000: { items: 3 },
      },
    });

    // Counter animation function
    const animateCounter = (target, setState) => {
      const speed = 100; // Speed of the counter animation
      const increment = target / speed;
      let currentCount = 0;

      const updateCounter = () => {
        currentCount += increment;
        if (currentCount < target) {
          setState(Math.ceil(currentCount));
          setTimeout(updateCounter, 30);
        } else {
          setState(target);
        }
      };

      updateCounter();
    };

    // Trigger the counter animations
    animateCounter(17, setExperienceCount);
    // animateCounter(2000, setStudentsCount); // 30k students
    animateCounter(50, setNationalitiesCount);
  }, []);
  const options = {
    loop: true,
    margin: 10,
    nav: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 3,
      },
    },
  };

  useEffect(() => {
    const query = "page=1&items_per_page=3";
    limitNews(query).then((res) => {
      setlimitNews(res.data);
    });
  }, []);

  const handleEnquiryChange = (e) => {
    const { name, value } = e.target;
    setEnquiry((prev) => ({ ...prev, [name]: value }));
  };

  const handleEnquirySubmit = async (e) => {
    e.preventDefault();
    setEnquiryStatus("");
    try {
      const res = await addEnquiryForm(enquiry);
      if (res.status) {
        setEnquiryStatus("Thank you! We will contact you soon.");
        setEnquiry({ name: "", phone: "", city: "", course: "", type: 1 });
      } else {
        setEnquiryStatus("Submission failed. Please try again.");
      }
    } catch (err) {
      setEnquiryStatus("Submission failed. Please try again.");
    }
  };

  return (
    <>
      {/* Add SEO Tags */}
      <div>
        <SEO
          fullTitle="Best Architecture College in Tamil Nadu | McGAN'S Ooty"
          description="Join McGAN'S School of Architecture, Ooty. A top-ranked college offering B.Arch & M.Arch courses affiliated with Anna University. Apply now for 2026 admission!"
          keywords="Top Architecture College in Tamil Nadu, B.Arch Colleges India, M.Arch Ooty, Anna University Architecture, Design School Ooty, Architecture Courses, Best architecture colleges in Tamil Nadu, Architecture institutes in Ooty, B.Arch colleges in Tamil Nadu"
          url="https://mcgansarch.com/"
        />
        <h1 style={{ display: "none" }}>
          Leading Architecture College in Ooty, Tamil Nadu
        </h1>
      </div>

      {/* <!--Start Banner Area--> */}
      <MyCarousel />
      {/* <!--End Banner Area--> */}
      {/* Start Campus Information */}
      <div className="campus-information-area pb-70">
        <div className="container">
          <div className="row align-items-center mt-5">
            <div
              className="col-lg-6"
              data-aos="fade-right"
              data-aos-easing="ease-in-sine"
              data-aos-duration="1300"
              data-aos-once="true"
            >
              <div className="campus-content pr-20">
                <div className="campus-title">
                  {/* <h2>We Welcome All</h2> */}
                  {/* <h2>Architecture Education at McGAN’S</h2> */}
                  <h3>A Top Architecture College in India.</h3>
                  <h4>McGAN’S OOTY School of Architecture</h4>
                  <p className="text-justify">
                    McGAN'S Ooty School of Architecture is the premier destination for students seeking a
                    <strong> top architecture college in Tamil Nadu</strong>. Located in the serene hills of the Nilgiris,
                    we offer world-class B.Arch and M.Arch programs affiliated with <strong>Anna University</strong>.
                  </p>
                  <p className="text-justify">
                    Our curriculum blends creative design theory with practical studio expertise, empowering future
                    architects to shape sustainable and innovative built environments across India and the globe.
                    With a strong focus on sustainability, innovation, and interdisciplinary collaboration,
                    McGAN’S nurtures future-ready architects.
                  </p>
                </div>

                <div className="counter">
                  <div className="row">
                    <div className="col-lg-4 col-4">
                      <div className="counter-card">
                        <h3>
                          <span>{experienceCount}</span>
                          <span className="target">+</span>
                        </h3>
                        <p>Years Of Experience</p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-4">
                      <div className="counter-card">
                        <h3>
                          <span>{studentsCount}</span>
                          <span className="target">+</span>
                        </h3>
                        <p>Students</p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-4">
                      <div className="counter-card">
                        <h3>
                          <span>{nationalitiesCount}</span>
                          <span className="target">+</span>
                        </h3>
                        <p>Industries</p>
                      </div>
                    </div>
                  </div>

                </div>
                <Link to="https://www.youtube.com/watch?v=-DzH5NOduXU&embeds_referring_euri=https%3A%2F%2Fold.mcgansarch.com%2F&source_ve_path=Mjg2NjY" className="default-btn btn">
                  Explore McGAN’S <i className="flaticon-next"></i>
                </Link>
                {/* <a
  href="https://mcgansarch.com/virtual-tour/index.html"
  className="default-btn btn"
  target="_blank"
  rel="noopener noreferrer"
>
  Visit Virtually <i className="flaticon-next"></i>
</a> */}

              </div>
            </div>
            <div className="col-lg-6">
              <div className="estemate-form">
                <h3 style={{ marginBottom: '20px' }}>Apply for Admission</h3>

                <form onSubmit={handleEnquirySubmit}>

                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Full Name"
                          name="name"
                          value={enquiry.name}
                          onChange={handleEnquiryChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Phone Number"
                          name="phone"
                          value={enquiry.phone}
                          onChange={handleEnquiryChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="City"
                          name="city"
                          value={enquiry.city}
                          onChange={handleEnquiryChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <select
                          className="form-control"
                          name="course"
                          value={enquiry.course}
                          onChange={handleEnquiryChange}
                          required
                        >
                          <option value="" disabled>
                            Select Course
                          </option>
                          <option value="barch">B Arch</option>
                          <option value="march">M Arch</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <button type="submit" className="default-btn btn">
                        Send Request
                        <i className="flaticon-paper-plane"></i>
                      </button>
                    </div>
                    {enquiryStatus && (
                      <div className="mt-2 text-success" style={{ marginTop: '10px', marginBottom: '20px' }}>{enquiryStatus}</div>
                    )}
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Start Academic Area */}
      <div className="academic-area pt-60 pb-70">
        <div className="container">
          <div className="section-title text-center">
            <h2>Academics</h2>
            <p>
              McGAN’S offers students a rigorous academic experience in a
              collaborative and supportive environment.
            </p>
          </div>

          <div className="row align-items-center">
            {/* Left Image Box */}
            <div
              className="col-lg-5 col-md-12 mb-4 mb-lg-0"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <div className="academic-image-box">
                <img
                  src="/assets/images/academics/4.webp"
                  width={6000}
                  height={4000}
                  alt="Academics Overview"
                  className="img-fluid rounded shadow"
                />
              </div>
            </div>

            {/* Right 4 Boxes */}
            <div className="col-lg-7 col-md-12">
              <div className="row g-4">
                {/* Box 1 */}
                <div className="col-md-6">
                  <div className="academic-card text-center p-4 shadow-sm rounded">
                    <h4>B.Arch</h4>
                    <p>
                      A comprehensive architecture program fostering creativity, innovation, and leadership, blending design with technology, theory, and history.
                    </p>
                    <Link to="/undergraduate" className="read-more-btn">
                      Explore<i className="flaticon-next ms-2"></i>
                    </Link>
                  </div>
                </div>

                {/* Box 2 */}
                <div className="col-md-6">
                  <div className="academic-card text-center p-4 shadow-sm rounded">
                    <h4>M.Arch</h4>
                    <p>
                      Master of Architecture (Environmental Architecture) — We are the only college offering Environmental Architecture in South India
                    </p>
                    <Link to="/postgraduate" className="read-more-btn">
                      Explore<i className="flaticon-next ms-2"></i>
                    </Link>
                  </div>
                </div>

                {/* Box 3 */}
                <div className="col-md-6">
                  <div className="academic-card text-center p-4 shadow-sm rounded">
                    <h4>M.Arch</h4>
                    <p>
                      Master of Architecture (M.Arch) in Urban Design - Welcome to the Master of Architecture (M.Arch) in Urban Design program at McGans Ooty School of
                      Architecture
                    </p>
                    <Link to="/march-urban" className="read-more-btn">
                      Explore<i className="flaticon-next ms-2"></i>
                    </Link>
                  </div>
                </div>

                {/* Box 4 */}
                <div className="col-md-6">
                  <div className="academic-card text-center p-4 shadow-sm rounded">
                    <h4>International Student</h4>
                    <p>
                      Students will be welcomed into the Unique & Serene Environment of
                      The Nilgiri Hills, facilitating a tranquil learning atmosphere.
                    </p>
                    <Link to="/international-student" className="read-more-btn">
                      Explore<i className="flaticon-next ms-2"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* End Academic Area */}
      {/* <div className="why-section">

</div> */}
      {/* <!--Start Education Area--> */}
      {/* <div className="eduction-area pb-70">
        <div className="container-fluid p-0 mt-5">
          <div className="section-title">
            <h2>Why McGAN’S</h2>
            <p className="text-justify whystyle">
              State-of-the-Art Facilities Access top-notch facilities and
              resources for an enhanced learning experience
            </p>
          </div>
          <div className="row g-0">
            <div
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="200"
              data-aos-once="true"
            >
              <div className="single-education-card bg-1">
                <div className="edication-content">
                  <div className="icon">
                    <i className="flaticon-college"></i>
                  </div>
                  <p>
                    <h3>Located In Panoramic Valley Of Ooty</h3>
                  </p>
                  <a
                    // href="academics-details.html"
                    className="read-more-btn white-color"
                  ></a>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="400"
              data-aos-once="true"
            >
              <div className="single-education-card bg-2">
                <div className="edication-content">
                  <div className="icon">
                    <i className="flaticon-student-with-graduation-cap"></i>
                  </div>
                  <p>
                    <h3>15 Years Strong Commitment To Teaching</h3>
                  </p>
                  <a
                    // href="academics-details.html"
                    className="read-more-btn white-color"
                  ></a>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="600"
              data-aos-once="true"
            >
              <div className="single-education-card bg-3">
                <div className="edication-content">
                  <div className="icon">
                    <i className="flaticon-college-graduation"></i>
                  </div>
                  <p>
                    <h3>All India Ranking By Outlook #8 </h3>
                  </p>
                  <a
                    // href="academics-details.html"
                    className="read-more-btn white-color"
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <!--End Education Area--> */}

      {/* <!--Start Campus Information--> */}
      <div className="campus-information-area pb-70">
        <div className="section-title">
          <h2>Students Testimonials</h2>
          <p>Journeys of Aspiration Our Students Transformative Experiences</p>
        </div>
        <div className="container">
          {studentStoriesList.map((story, index) => (
            <div className="container" key={index}>
              <div className="row align-items-center mt-5">
                {index % 2 === 0 ? (
                  <>
                    <div className="col-lg-6">
                      <div className="campus-content pr-20">
                        <div className="campus-title">
                          <h4>{story.title}</h4>
                          <p className="text-justify">{story.description}</p>
                          {/* <Link to="#">
                          <p className="text-justify">{story.pra}</p>
                          </Link> */}
                          <p>
                            <b>{story.student_name}</b>
                            <br /> {story.year}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="campus-image pl-20">
                        {story.video && story.video !== "null" && story.video !== "" && (
                          <div className="video-container">
                            <iframe
                              src={`https://www.youtube.com/embed/${getYouTubeID(
                                story.video
                              )}?autoplay=1&mute=1&loop=1&playlist=${getYouTubeID(
                                story.video
                              )}&cc_load_policy=1&cc_lang_pref=en`}
                              title="Student Story Video"
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                              referrerpolicy="strict-origin-when-cross-origin"
                            ></iframe>
                          </div>




                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-lg-6">
                      <div className="campus-image pl-20">
                        <div className="video-container">
                          <iframe
                            src={`https://www.youtube.com/embed/${getYouTubeID(
                              story.video
                            )}?autoplay=1&mute=1&loop=1&playlist=${getYouTubeID(
                              story.video
                            )}&cc_load_policy=1&cc_lang_pref=en`}
                            title="Student Story Video"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            referrerpolicy="strict-origin-when-cross-origin"
                          ></iframe>
                        </div>

                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="campus-content pr-20">
                        <div className="campus-title">
                          <h4>{story.title}</h4>
                          <p className="text-justify">{story.description}</p>
                          {/* <Link>
                          <p className="text-justify">{story.pra}</p>
                          </Link> */}
                          <p>
                            <b>{story.student_name}</b>
                            <br /> {story.year}
                          </p>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          ))}


          {studentStoriesList.length >= items_per_page && (
            <div className="content studentstory">
              <Link
                to="/student-story-details"
                className="read-more-btn active studentstory"
              >
                More on Students Story
                <i className="flaticon-next"></i>
              </Link>
            </div>
          )}
        </div>
      </div>

      {/* <!--End Campus Information--> */}

      {/* <!--Start Campus Life Area--> */}
      <div class="campus-life-area ptb-50 Campus">
        <div class="container">
          <div class="section-title">
            <h2>Campus Life</h2>
            <p>Thriving Together In a lively Campus Community. </p>
          </div>
          <div class="row justify-content-center">
            <div
              class="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="200"
              data-aos-once="true"
            >
              <div class="single-campus-card card-height  Campus">
                <div class="img">
                  <Link to="/campus-studiodetails">
                    <img
                      src="../../assets/images/campus-life/lab.webp"
                      title="Campus"
                      width={365}
                      height={258}
                      alt="lab"
                    />
                  </Link>
                </div>
                <div class="campus-content">
                  <Link to="/campus-studiodetails">
                    <span>Computer Studio</span>
                  </Link>
                </div>
              </div>
            </div>
            <div
              class="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="400"
              data-aos-once="true"
            >
              <div class="single-campus-card card-height">
                <div class="img">
                  <Link to="/campus-librarydetails">
                    <img
                      src="../../assets/images/campus-life/library.webp"
                      width={365}
                      height={258}
                      title="Campus1"
                      alt="library"
                    />
                  </Link>
                </div>
                <div class="campus-content">
                  <Link to="/campus-librarydetails">
                    <span>Library</span>
                  </Link>
                </div>
              </div>
            </div>
            <div
              class="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="600"
              data-aos-once="true"
            >
              <div class="single-campus-card card-height">
                <div class="img">
                  <Link to="/campus-hosteldetails">
                    <img
                      src="../../assets/images/campus-life/hostel.webp"
                      width={365}
                      height={258}
                      
                      title="Hostel"
                      alt="hostel"
                    />
                  </Link>
                </div>
                <div class="campus-content">
                  <Link to="/campus-hosteldetails">
                    <span>Hostel</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="more-health-care text-center">
          <p>
            <Link to="/campus" className="read-more-btn active">
              More on Campus Life
              <i className="flaticon-next"></i>
            </Link>
          </p>
        </div>
      </div>
      {/* <!--End Campus Life Area--> */}

      {/* <!--Start Lates News Area--> */}
      {/* <div className="lates-news-area ptb-100 bg-f4f6f9">
        <div className="container">
          <div className="section-title">
            <h2>News</h2>
            <p>Expand Your Knowledge At Our Interactive Learning Center</p>
          </div>

          <OwlCarousel className="news-slider owl-theme" {...options}>
            {newsLimit.map((items, index) => (
              <div className="single-news-card style2">
                <div className="news-img" key={index}>
                  <Link
                    to={`/news-details/${items?.primaryId}`}
                    className="read-more-btn"
                  >
                    <img
                      src={items.image}
                      width={365}
                      height={258}
                      title="Cultural"
                      alt="Cultural Fest 2023"
                    />
                  </Link>
                </div>
                <div className="news-content">
                  <Link
                    to={`/news-details/${items?.primaryId}`}
                    className="news-title-link"
                  >
                    <h3>{items.title}</h3>
                  </Link>
                  {items.description.split(" ").slice(0, 8).join(" ")}
                  <Link
                    to={`/news-details/${items?.primaryId}`}
                    className="read-more-btn"
                  >
                    <span className="ReadMoreStyle"> Read More</span>
                    <i className="flaticon-next"></i>
                  </Link>
                </div>
              </div>
            ))}
           
          </OwlCarousel>
          <div class="more-health-care text-center">
            <p>
              <Link to="/news" className="read-more-btn active">
                More on News
                <i className="flaticon-next"></i>
              </Link>
            </p>
          </div>
        </div>
      </div> */}
      {/* <!--End News Area--> */}
      <section className="life-section">
        {/* Header */}
        <div className="life-header" data-aos="fade-down">
          <h2>Life In McGAN’S</h2>
          <p>
            From rigorous academics to the beautiful greens of our nature filled
            campus to the activity of student life, McGAN’s has it all
          </p>

        </div>

        {/* Floating Buttons */}
        {/* <div className="floating-buttons" data-aos="zoom-in">
        <button className="float-btn active">LIVE</button>
        <button className="float-btn">LEARN</button>
      </div> */}

        {/* Image Grid */}
        <div className="life-grid">
          {galleryImages.length > 0 ? (
            galleryImages.map((item, index) => (
              <div key={index} className="grid-item" data-aos="zoom-in">
                <img
                  src={item.image}
                  alt={item.title || `Gallery ${index + 1}`}
                  loading="lazy"
                  width={getDims(item.image).width}
                  height={getDims(item.image).height}
                />
              </div>
            ))
          ) : (
            <p className="loading-text">Loading images...</p>
          )}
        </div>
        <div className="floating-buttons">
          <Link to="/gallery">
            <button className="view-btn">
              View All <span>»</span>
            </button>
          </Link>
        </div>
      </section>
      <ExperienceMcgans />
      {/* Start Company Carousel */}
      <div className="company-carousel-area ptb-50">
        <div className="container">
          <div className="section-title">
            <h2>Our Students Placed in</h2>
            <p>Top companies where our students are placed</p>
          </div>
          <OwlCarousel
            className="company-slider owl-theme"
            loop
            margin={100}
            nav={false}
            autoplay
            autoplayTimeout={2500}
            responsive={{
              0: { items: 2 },
              600: { items: 4 },
              1000: { items: 6 },
            }}
          >
            {recruiter && recruiter.length > 0 ? (
              recruiter.map((item, index) => (
                <div className="company-item text-center" key={index}>
                  <img
                    src={item.image}
                    alt={item.name || "Recruiter"}
                    width={100}
                    height={100}
                    style={{ objectFit: "contain" }}
                  />
                </div>
              ))
            ) : (
              <div className="company-item text-center">
                <p>No recruiters found.</p>
              </div>

            )}
          </OwlCarousel>
        </div>
      </div>

      {/* <VirtualTour/> */}

      {/* End Company Carousel */}
      {/* <!--End Campus Life Area--> */}

    </>
  );
};
